import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@dashboard/router/routeNames'

const splittestingRoutes: RouteRecordRaw[] = [
  {
    path: 'split-tests',
    name: ROUTES.SPLIT_TESTS,
    component: () => import('./pages/SplitTestsIndex.vue'),
    meta: {
      title: 'A/B Testing',
      description: 'Every A/B test across campaigns, flows, questions and offers.'
    }
  }
]

export default splittestingRoutes
